(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["prova-social-carrossel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-testimonial-carousel]').forEach((carousel) => {
    if (carousel.dataset.rkInitialized === 'true') return;
    carousel.dataset.rkInitialized = 'true';

    const track = carousel.querySelector('[data-rk-track]');
    const cards = [...track.children];
    const previous = carousel.querySelector('[data-rk-prev]');
    const next = carousel.querySelector('[data-rk-next]');
    const dots = carousel.querySelector('[data-rk-dots]');
    const openReviewButton = carousel.querySelector('[data-rk-open-review-form]');

    if (openReviewButton) {
      openReviewButton.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('rk:open-review-form'));
      });
    }

    if (!cards.length || !dots) return;

    const step = () => cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
    const activeIndex = () => Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / step())));

    cards.forEach((card, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `${dots.getAttribute('aria-label')} ${index + 1}`);
      dot.setAttribute('aria-current', String(index === 0));
      dot.addEventListener('click', () => track.scrollTo({ left: step() * index, behavior: 'smooth' }));
      dots.appendChild(dot);
    });

    const sync = () => {
      const current = activeIndex();
      [...dots.children].forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
    };

    if (previous) previous.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' && previous) previous.click();
      if (event.key === 'ArrowRight' && next) next.click();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
